const createLinearScale = (
  domain: [number, number],
  rangeTop: number,
  rangeBottom: number,
) => {
  const [domainMin, domainMax] = domain;
  const rangeSpan = rangeBottom - rangeTop;

  if (domainMax === domainMin) {
    return () => rangeTop;
  }

  return (value: number) =>
    rangeTop + ((domainMax - value) / (domainMax - domainMin)) * rangeSpan;
};

export default createLinearScale;
